import { render, staticRenderFns } from "./CrazyAppList.vue?vue&type=template&id=9b629e02&scoped=true&"
import script from "./CrazyAppList.vue?vue&type=script&lang=js&"
export * from "./CrazyAppList.vue?vue&type=script&lang=js&"
import style0 from "./CrazyAppList.vue?vue&type=style&index=0&id=9b629e02&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b629e02",
  null
  
)

export default component.exports